
<script>
export default {
    created() {
    },
    data() {
        return {
            form: {
                userAccount: '',
                password: ''
            },
            loginOption: {
                errMsg: '',
                loading: false
            }
        };
    },
    methods: {
        async login() {
            this.loginOption.loading = true;
            try {
                const {code, data, msg} = await  this.$store.dispatch('getLogin', this.form);
                if (!Object.is(code, 200)) {
                    this.loginOption.errMsg = msg || '用户名密码错误';
                } else {
                     this.loginOption.errMsg = '';
                     localStorage.setItem('tk', data);
                     this.$store.dispatch('zft/getCityList', {threeLevel: false});
                     this.menu();
                }
            } catch (e) {
                throw e;
            } finally {
                this.loginOption.loading = false;
            }
        },
        async menu() {
            const {data} = await this.$store.dispatch('zft/getMenuList');
            const path = data[0].children[0].menuLink;
            this.$router.push({path: path});
        }
    },
};
</script>
<template>
<div class="login">
    <div class="login-contain">
        <header class="login-contain-title">
            政务通后台管理系统
        </header>
        <div class="contain-form">
            <div class="contain-form-row">
                <el-input v-model="form.userAccount"
                    placeholder="请输入账户"
                >
                    <i slot="prefix" class="el-input__icon el-icon-user"></i>
                </el-input>
            </div>
            <div class="contain-form-row">
                <el-input v-model="form.password" show-password
                    placeholder="请输入密码"
                >
                    <i slot="prefix" class="el-input__icon el-icon-user"></i>
                </el-input>
            </div>
            <div class="tip">{{loginOption.errMsg}}</div>
            <div class="contain-form-row">
                <el-button type="primary" class="login-btn" @click="login" :loading="loginOption.loading">登陆</el-button>
            </div>
        </div>
    </div>
</div>
</template>
<style scoped lang="stylus">
.login
    display flex
    align-items center
    justify-content center
    height 100vh
    width 100%
    background url(../../assets/login.jpeg)
    background-size contain
    .login-contain-title
        text-align center
        margin-bottom 30px
        font-size 30px
        font-weight bolder
        color #fff
    .contain-form
        background #efefef
        padding 30px
        border-radius 10px
        width 260px
        .contain-form-row
            margin-bottom 20px
        .login-btn
            width 100%
    .tip
       height 30px
       color red
       margin-top -18px

</style>
